import ECode from './eCode';

// 高级功能不可用状态
export const FUNCTION_DISABLED = 0;
// 功能用量无限制
export const UNLIMITED = -1;

export const SUITE_ERROR = [
    ECode.SUITE_CONSENT_NOT_ACTIVATED,
    ECode.TENANT_SUITE_CONSENT_NOT_FOUND,
    ECode.SUITE_CONSENT_CORP_SCOPE_MANAGED_BY_INTEGRATE_SYNC,
    ECode.SUITE_AUTHENTICATION_OUT_OF_SCOPE,
    ECode.SUITE_AUTHENTICATION_OUT_OF_SCOPE_IS_SA,
    ECode.SUITE_EXCEED_SCOPE_MEMBER_NOT_SA,
    ECode.SUITE_EXCEED_SCOPE_MEMBER_IS_SA,
    ECode.SUITE_EXCEED_SCOPE_EXTERNAL_MEMBER_NOT_SA,
    ECode.SUITE_EXCEED_SCOPE_EXTERNAL_MEMBER_IS_SA
];
